// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-input-element:disabled,
.mat-date-range-input-inner[disabled],
.mat-form-field-appearance-outline.mat-form-field-disabled .mat-form-field-outline {
  color: #000;
}

::ng-deep .white .mat-form-field-wrapper {
  padding-bottom: 0;
}

.example-month-picker .mat-calendar-period-button {
  pointer-events: none;
}

.example-month-picker .mat-calendar-arrow {
  display: none;
}

::ng-deep .white .mat-form-field-wrapper {
  padding-bottom: 0;
}

.clearButton {
  position: absolute;
  left: -17px;
  top: 6.5px;
  cursor: pointer;
  color: #757575;
}

.redStar {
  color: red;
}`, "",{"version":3,"sources":["webpack://./src/app/components/date-picker/date-picker.component.scss"],"names":[],"mappings":"AAAA;;;EAGI,WAAA;AACJ;;AAGI;EACI,iBAAA;AAAR;;AAIA;EACI,oBAAA;AADJ;;AAIA;EACI,aAAA;AADJ;;AAKI;EACI,iBAAA;AAFR;;AAMA;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;AAHJ;;AAMA;EACI,UAAA;AAHJ","sourcesContent":[".mat-input-element:disabled,\n.mat-date-range-input-inner[disabled],\n.mat-form-field-appearance-outline.mat-form-field-disabled .mat-form-field-outline {\n    color: #000;\n}\n\n::ng-deep {\n    .white .mat-form-field-wrapper {\n        padding-bottom: 0;\n    }\n}\n\n.example-month-picker .mat-calendar-period-button {\n    pointer-events: none;\n}\n\n.example-month-picker .mat-calendar-arrow {\n    display: none;\n}\n\n ::ng-deep {\n    .white .mat-form-field-wrapper {\n        padding-bottom: 0;\n    }\n}\n\n.clearButton {\n    position: absolute;\n    left: -17px;\n    top: 6.5px;\n    cursor: pointer;\n    color: #757575;\n}\n\n.redStar{\n    color: red;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
